import React from "react";

export const FreezingDrizzleIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="08" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M64.582 52.347c4.969 0 8.986-3.955 8.986-8.821 0-4.867-4.017-8.822-8.986-8.822-.796 0-1.578.102-2.332.3a1.55 1.55 0 01-1.93-1.291c-.586-4.352-4.383-7.651-8.907-7.651-.105 0-.211.002-.316.005a1.55 1.55 0 01-1.567-1.22c-1.477-6.8-7.62-11.749-14.797-11.749-7.777 0-14.26 5.792-15.051 13.326a1.55 1.55 0 01-1.457 1.386c-6.604.36-11.793 5.74-11.793 12.259 0 6.775 5.59 12.278 12.498 12.278h45.652zm0-20.741c6.669 0 12.085 5.331 12.085 11.92 0 6.589-5.416 11.92-12.085 11.92H18.93c-8.608 0-15.596-6.88-15.596-15.377 0-7.749 5.826-14.197 13.445-15.232C18.29 16.347 25.813 10 34.733 10c8.209 0 15.306 5.39 17.521 12.992 5.143.35 9.46 3.889 10.808 8.707a12.348 12.348 0 011.52-.093zM28.639 69.906a4.648 4.648 0 110-9.296 4.648 4.648 0 010 9.296zm0-3.099a1.55 1.55 0 100-3.098 1.55 1.55 0 000 3.098z"
                        fill="#717277"
                    />
                    <path
                        d="M53.674 63.797a1.55 1.55 0 10-2.191-2.19l-5.113 5.112a1.55 1.55 0 002.191 2.19l5.113-5.112z"
                        fill="#9ADAFF"
                    />
                </g>
            </g>
        </g>
    </svg>
);
